export default __webpack_public_path__ + "static/media/new-design.b1d48cfd.png";